import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';

const AdminLayout: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#F7F8FA] font-sans selection:bg-[#006d5b]/20 selection:text-[#006d5b]">
      
      {/* Sidebar with Mobile State */}
      <AdminSidebar 
        isOpen={isSidebarOpen} 
        onClose={() => setIsSidebarOpen(false)} 
      />

      {/* Main Content Wrapper */}
      {/* ml-0 for mobile (full width), ml-64 for desktop (pushed by sidebar) */}
      <div className="ml-0 lg:ml-64 flex flex-col min-h-screen transition-all duration-300">
        
        {/* Header with Toggle Function */}
        <AdminHeader onMenuToggle={() => setIsSidebarOpen(!isSidebarOpen)} />
        
        <main className="pt-24 pb-10 px-4 lg:px-8">
          <div className="max-w-[1600px] mx-auto">
             <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;